import type {TypedUseSelectorHook} from 'react-redux';

import {configureStore} from '@reduxjs/toolkit';
import {useDispatch, useSelector} from 'react-redux';

import {chortkeSlice} from './slices/chortke/slicer';
import {componentsSlicer} from './slices/components/slicer';
import {couponSlicer} from './slices/coupon/slicer';
import {cpcSlicer} from './slices/cpc/slicer';
import {customDealSlicer} from './slices/custom-deal/slicer';
import {dashboardSlice} from './slices/dashboard/slicer';
import {extraDeliverySlicer} from './slices/extra-delivery/slicer';
import {homeSlice} from './slices/home/slicer';
import {invoiceSlicer} from './slices/invoice/slicer';
import {loginSlice} from './slices/login/slicer';
import {notificationSlicer} from './slices/notification/slicer';
import {orderSlice} from './slices/order/slicer';
import {pinSlicer} from './slices/pin/slicer';
import {productsSlice} from './slices/products/slicer';
import {profileSlice} from './slices/profile/slicer';
import {promotionCenterSlicer} from './slices/promotion-center/slicer';
import {reportSlicer} from './slices/report/slicer';
import {serviceSlice} from './slices/services/slicer';
import {ticketSlicer} from './slices/ticket/slicer';
import {trackingSlicer} from './slices/tracking/slicer';
import {vendorProSlicer} from './slices/vendor-pro/slicer';
import {registerationSlicer} from './slices/vendor-registration/slicer';
import {vendorScoreSlicer} from './slices/vendor-score/slicer';

export const store = configureStore({
  reducer: {
    login: loginSlice.reducer,
    dashboard: dashboardSlice.reducer,
    services: serviceSlice.reducer,
    profile: profileSlice.reducer,
    report: reportSlicer.reducer,
    order: orderSlice.reducer,
    home: homeSlice.reducer,
    chortke: chortkeSlice.reducer,
    promotionCenter: promotionCenterSlicer.reducer,
    customDeal: customDealSlicer.reducer,
    components: componentsSlicer.reducer,
    vendorScore: vendorScoreSlicer.reducer,
    pin: pinSlicer.reducer,
    ticket: ticketSlicer.reducer,
    tracking: trackingSlicer.reducer,
    notification: notificationSlicer.reducer,
    vendorRegistration: registerationSlicer.reducer,
    cpc: cpcSlicer.reducer,
    invoice: invoiceSlicer.reducer,
    products: productsSlice.reducer,
    coupon: couponSlicer.reducer,
    vendorPro: vendorProSlicer.reducer,
    extraDelivery: extraDeliverySlicer.reducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
